import { Text, type StylableProps } from "@mdotm/shadcn/legacy/components";
import { toClassName, toClassListRecord } from "@mdotm/shadcn/legacy/react-extensions";
import { UserCircle, type UserCircleProps } from "./UserCircle";
import type { RichAccessControl } from "@eu.mdotm.api/smart-workspaces";

export function ACLEntryPreview({
	palette,
	user,
	isCurrentUser = false,
	className,
	style,
}: ACLEntryPreviewProps): React.JSX.Element {
	return (
		<div
			className={toClassName({ "flex items-center gap-2 min-w-0": true, ...toClassListRecord(className) })}
			style={style}
		>
			<div className="grow-0">
				{user ? (
					<UserCircle variant="name" palette={palette} firstName={user.name ?? "-"} lastName={user.surname ?? "-"} />
				) : (
					<UserCircle variant="add" palette={palette} />
				)}
			</div>
			<div className="grow min-w-0">
				{user ? (
					<>
						<Text as="div" type="Body/L/Bold" className="truncate">
							{user.name ?? ""} {user.surname} {isCurrentUser ? "(you)" : ""}
						</Text>
						<Text as="div" type="Body/M/Book" className="truncate">
							{user.email}
						</Text>
					</>
				) : (
					<Text as="div" type="Body/L/Bold" className="truncate">
						Add all
					</Text>
				)}
			</div>
		</div>
	);
}
export type ACLEntryPreviewProps = {
	palette: UserCircleProps["palette"];
	user?: RichAccessControl;
	isCurrentUser?: boolean;
} & StylableProps;
